export default __webpack_public_path__ + "static/media/1.11c9b4f1.png";